module.exports = __webpack_public_path__ + "img/4.62f254e5.png";